import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import  AuthContext from '../context/authContext'; // Ensure the path is correct

const Register = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://moviesearch-t67w.onrender.com/users/register', {
        fullName,
        email,
        username,
        password,
      });

      if (response.status === 201) {
        // Automatically log in the user after registration
        login(response.data.token); 
        navigate('/login'); // Redirect to the login page
      }
    } catch (err) {
        if (err.response?.status === 409) {
          setError('User with this email or username already exists.');
        } else {
          setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        }
      }
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleSubmit}>
        <h1>Register</h1>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <div className="mb-3">
          <label>Full Name:</label>
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Register</button>
      </form>
    </div>
);

};

export default Register;
